import { render } from "./Reads.vue?vue&type=template&id=28f2a2e5"
import script from "./Reads.vue?vue&type=script&lang=js"
export * from "./Reads.vue?vue&type=script&lang=js"

import exportComponent from "/home/grosscol/workspace/bravue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__